const ACCESS_KEY = 'access_token';
const EXPIRES_AT_KEY = 'access_token_expires_at';

export function setSession({ access_token, expires_in }) {
  localStorage.setItem(ACCESS_KEY, access_token);

  // Se o backend não enviar expires_in, assume 1 hora (3600s)
  const expiresInSeconds = expires_in || 3600;

  const safetyMs = 60_000; // 1 minuto de margem
  const expiresAt = Date.now() + expiresInSeconds * 1000 - safetyMs;

  localStorage.setItem(EXPIRES_AT_KEY, String(expiresAt));
}

export function getAccessToken() {
  return localStorage.getItem(ACCESS_KEY);
}

export function isSessionValid() {
  const token = getAccessToken();
  if (!token) return false;

  const expiresAtRaw = localStorage.getItem(EXPIRES_AT_KEY);
  if (!expiresAtRaw) return true;

  const expiresAt = Number(expiresAtRaw);
  if (!Number.isFinite(expiresAt)) return true;

  return Date.now() < expiresAt;
}

export function clearSession() {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(EXPIRES_AT_KEY);
}
